/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type InvoiceQuickView_statusTypes$ref: FragmentReference;
declare export opaque type InvoiceQuickView_statusTypes$fragmentType: InvoiceQuickView_statusTypes$ref;
export type InvoiceQuickView_statusTypes = {|
  +enumValues: ?$ReadOnlyArray<{|
    +name: string,
    +description: ?string,
  |}>,
  +$refType: InvoiceQuickView_statusTypes$ref,
|};
export type InvoiceQuickView_statusTypes$data = InvoiceQuickView_statusTypes;
export type InvoiceQuickView_statusTypes$key = {
  +$data?: InvoiceQuickView_statusTypes$data,
  +$fragmentRefs: InvoiceQuickView_statusTypes$ref,
};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "InvoiceQuickView_statusTypes",
  "type": "__Type",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "enumValues",
      "storageKey": null,
      "args": null,
      "concreteType": "__EnumValue",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "name",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "description",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'c23862c2c2f862f9505120dfffd37ced';
module.exports = node;
